import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import React from 'react';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import { appendCellFormatter } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import { RowRenderer } from './RowRenderer.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-utilities/utils';
import './ToolbarTrigger.js';
import 'styled-components';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/MoreOptionsVert';
import '../../rowSizes.js';

var decorateColumns = function decorateColumns(columns) {
  var lastColumn = columns[columns.length - 1];
  return [].concat(_toConsumableArray(columns.slice(0, -1)), [appendCellFormatter([function (value) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, value, /*#__PURE__*/React.createElement("div", {
      style: {
        width: 34,
        maxWidth: 34,
        overflow: 'hidden'
      }
    }));
  }], lastColumn, 'fixedFormatters')]);
};

var decorateRenderers = function decorateRenderers(renderers, grid) {
  var Row = renderers.body.row;
  renderers.body.row = RowRenderer(Row, grid);
  return renderers;
};

var ToolbarPlugin = createInstancePlugin('toolbar', {
  decorateRenderers: decorateRenderers,
  decorateColumns: decorateColumns
});

export { ToolbarPlugin };
//# sourceMappingURL=ToolbarPlugin.js.map
